"use strict";
// this file is used to hide headers, footers, and related, for the mobile app
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var e_1, _a;
var _b;
// list of ids for elements we want to remove (mainly the header and footer)
var removeIds = ['header', 'header-adjust', 'footer', 'announcement-bar'];
var queryString = window.location.search;
var urlParams = new URLSearchParams(queryString);
var showContentOnly = urlParams.get('showContentOnly');
if (showContentOnly) {
    try {
        for (var removeIds_1 = __values(removeIds), removeIds_1_1 = removeIds_1.next(); !removeIds_1_1.done; removeIds_1_1 = removeIds_1.next()) {
            var id = removeIds_1_1.value;
            var element = document.getElementById(id);
            if (!element)
                continue;
            (_b = element.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(element);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (removeIds_1_1 && !removeIds_1_1.done && (_a = removeIds_1.return)) _a.call(removeIds_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
